import { DatePipe } from '@angular/common';
import { FatalDiagnosticError } from '@angular/compiler-cli/src/ngtsc/diagnostics';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthorityStatus, Vacation, VacationRow } from 'src/app/models/CalendarModels';
import { CalendarService } from 'src/app/services/calendar.service';
import { CalendarComponent } from '../calendar/calendar.component';
import { AccountVacationDialogComponent } from '../account-vacation-dialog/account-vacation-dialog.component';
import { ClassScheduleListComponent } from '../class-schedule-list/class-schedule-list.component';
import { VacationListComponent } from '../vacation-list/vacation-list.component';
import { StudentListComponent } from '../student-list/student-list.component';
import { StudentsSearchComponent } from '../students-search/students-search.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScheduleRow } from 'src/app/models/ScheduleRow';
import { Schedule_ep } from 'src/app/models/Schedule_ep';
import { ClassScheduleRequest, ClassVacationRequest, VacationRequest } from 'src/app/models/CalendarRequest';
import { AuthoritiesStatusDialogComponent } from '../authorities-status-dialog/authorities-status-dialog.component';
import { AddClassScheduleDialogComponent } from '../add-class-schedule-dialog/add-class-schedule-dialog.component';


@Component({
  selector: 'app-institution-calendar-main',
  templateUrl: './institution-calendar-main.component.html',
  styleUrls: ['./institution-calendar-main.component.scss'],
})
export class InstitutionCalendarMainComponent implements OnInit {
  @ViewChild(CalendarComponent) calendar: CalendarComponent;
  @ViewChild(ClassScheduleListComponent) classSchedulesList: ClassScheduleListComponent;
  @ViewChild(VacationListComponent) vacationsList: VacationListComponent;
  @ViewChild(StudentListComponent) studentsList: StudentListComponent;
  @ViewChild(StudentsSearchComponent) studentsSearch: StudentsSearchComponent;
  selectedDays: any[] = [];
  mainScheduleSelected: boolean = true;
  public selectedVacations: Vacation[] = null;
  selectAllStudentsValue: boolean = false;
  disableButton: boolean = true;

  scheduleChosen: boolean = false;
  selectedScheduleRows: ScheduleRow[];

  vacationChosen: boolean = false;
  selectedVacationRows: VacationRow[];

  constructor(public dialog: MatDialog, public calendarSvc: CalendarService, private spinner: NgxSpinnerService) {
    this.loadAllData();
    this.calendarSvc.calendarChosen.subscribe(res => {
      if (res.length == 0) {
        this.scheduleChosen = false;
      }
      else {
        this.scheduleChosen = true;
      }
      this.selectedScheduleRows = res;
    });
    this.calendarSvc.vacationChosen.subscribe(res => {
      if (res.length == 0) {
        this.vacationChosen = false;
      }
      else {
        this.vacationChosen = true;
      }
      this.selectedVacationRows = res;
    })
  }

  ngOnInit() {
    this.calendarSvc.dataService.refreshPageSubject.asObservable().subscribe(() => this.loadAllData())
  }

  loadAllData() {
    this.calendarSvc.spinnerSubjectEmit(true);
    this.calendarSvc.getModalOptions();
    this.calendarSvc.loadSchedulesAndVacationLists();
    this.calendarSvc.spinnerSubject.subscribe(loading => {
      if (loading) {
        this.spinner.show();
      } else {
        this.spinner.hide();
      }
    });
  }

  // getSelectedDays(value) {
  //   this.selectedDays = value;
  //   this.selectedDays = this.selectedDays.sort((b, a) => new Date(b.date).getTime() - new Date(a.date).getTime());
  // }

  onSelectedDay(dayList: any[]) {
    if (dayList.length == 0)
      this.disableButton = true;
    else
      this.disableButton = false;
    if (dayList.length == 1) {
      this.openDialog(true);
    }
  }


  openDialog(openAutomaticly: boolean): void {
    const vacationDates: any[] = [];
    let dates: any[] = [];
    this.selectedDays = this.calendar.selectedDays.sort((b, a) => new Date(b.date).getTime() - new Date(a.date).getTime());
    dates = this.selectedDays;
    let item = null;
    switch (this.selectedDays.length) {
      case 0:
        return;
      case 1:
        item = this.calendarSvc.vacations?.find(x =>
          x.Date && x.DateTo &&
          new Date(x.Date) <= new Date(this.calendarSvc.transformDate(this.selectedDays[0].date, 'yyyy-MM-dd')) &&
          new Date(x.DateTo) >= new Date(this.calendarSvc.transformDate(this.selectedDays[0].date, 'yyyy-MM-dd'))
        );
        break;
      default://2+
        let anyDayHasVacation = this.calendarSvc.vacations && this.selectedDays.some(x => this.calendarSvc.vacations.some(y => y.Date == this.calendarSvc.transformDate(this.selectedDays[0].date, 'yyyy-MM-dd')));
        if (anyDayHasVacation) {
          alert("יש לבחור ימים פנויים ליצירת חופשה");
          return;
        }
    }
    if (openAutomaticly && !item) {
      return;
    }

    if (item != null) {
      const startDate = new Date(item.Date);
      const endDate = new Date(item.DateTo);

      for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
        vacationDates.push({
          date: d.toISOString().split('T')[0],
          str: `${d.getDate()}/${d.getMonth() + 1}`,
          otherProperty: null
        });
      }
      dates = vacationDates;
    }


    const dialogRef = this.dialog.open(AccountVacationDialogComponent, {
      panelClass: 'full-width-dialog',
      hasBackdrop: true,
      autoFocus: true,
      disableClose: true,
      data: { dates: dates, item: item },
    });
    dialogRef.afterClosed().subscribe(toRefresh => {
      this.selectedDays = this.calendar.selectedDays = [];
      this.calendar.clearBackgroundDatesToUnselected();
      if (toRefresh)
        this.calendar.setScheduleHoursInMonth();
      this.calendar.loadVacationsData();
    });
  }

  selectScheduleType(val: number) {
    if (val == 0)
      this.mainScheduleSelected = true;
    else
      this.mainScheduleSelected = false;
  }

  fillSchedule(event) { }

  selectAllStudents(allSelected) {
    this.selectAllStudentsValue = allSelected;
  }
  setSelectedVacations(value) {
    this.selectedVacations = value;
  }
  callbackLoadVacation() {
    this.studentsList.unSelectAll();
    this.calendarSvc.getVacationsForClasses();
    //this.vacationsList.loadVacations(() => { this.calendarSvc.filterCalendar(this.studentsSearch.dataFilter) });

  }
  callbackLoadClassSchedules() {
    this.calendarSvc.isNoonMode = false;
    this.studentsList.unSelectAll();
    this.classSchedulesList.unSelectAll();
    this.calendarSvc.getStudents();
    this.calendarSvc.getSchedulesForClasses();
    // this.classSchedulesList.loadSchedules(() => { this.calendarSvc.filterCalendar(this.studentsSearch.dataFilter) });
  }

  changeStatus(): void {
    if (this.mainScheduleSelected)
      this.sendCancelForSchedule();
    else
      this.sendCancelForVacation();
  }

  sendCancelForVacation() {

    const request = new ClassVacationRequest();
    request.VacationsToUpdate = [];
    this.selectedVacationRows.forEach(vctn => {
      console.log("vacation", vctn);
      let vac = new VacationRequest();
      vac.Id = vctn.VacationForAccountId;
      vac.ParentId = vctn.VacationId;
      vac.Class = vctn.Class;
      vac.ClassCode = vctn.ClassCode;
      vac.Students = this.calendarSvc.mapStudentsFromStringToObject(this.calendarSvc.classVacsationsList.find(x => x.ClassCode == vac.ClassCode).Students);
      request.VacationsToUpdate.push(vac)
    });
    this.calendarSvc.spinnerSubjectEmit(true)
    this.calendarSvc.changeVacationStatusToCancelWait(request).then((res: any) => {
      this.calendarSvc.spinnerSubjectEmit(false);
      if (!this.calendarSvc.dataService.IsError(res)) {
        this.calendarSvc.getVacationsForClasses();
      }
    }).catch(err => {
      debugger
      this.calendarSvc.spinnerSubjectEmit(false);
      alert("ארעה שגיאה");
    });
  }

  sendCancelForSchedule() {
    const request = new ClassScheduleRequest();
    request.SchedulesToUpdate = [];
    this.selectedScheduleRows.forEach(scdl => {
      let scdlep = new Schedule_ep();
      scdlep.Id_e = scdl.Id_e;
      scdlep.Id_p = scdl.Id_p;
      request.SchedulesToUpdate.push(scdlep)
    });
    this.calendarSvc.spinnerSubjectEmit(true)
    this.calendarSvc.changeSchduleStatusToCancelWait(request).then((res: any) => {
      this.calendarSvc.spinnerSubjectEmit(false);
      if (!this.calendarSvc.dataService.IsError(res)) {
        this.calendarSvc.getSchedulesForClasses();
      }
    }).catch(err => {
      debugger
      this.calendarSvc.spinnerSubjectEmit(false);
      alert("ארעה שגיאה");
    });
  }

  setCancelButtonDisabled(): boolean {
    if (this.mainScheduleSelected)
      return !this.scheduleChosen;
    else
      return !this.vacationChosen;
  }

  setAuthorityStatusButtonDisabled() {
    let res = false;
    if (this.mainScheduleSelected)
      res = !(this.scheduleChosen && this.selectedScheduleRows.length == 1 /*&& this.selectedScheduleRows[0].Status.viewValue == "אושר חלקית"*/);
    else
      res = !(this.vacationChosen && this.selectedVacationRows.length == 1 /*&& this.selectedVacationRows[0].Status == "אושר חלקית"*/);
    // console.log("res", res);
    return res;
  }

  manageAuthorityStatus() {
    let item = null, tmp = null;
    if (this.mainScheduleSelected) {
      tmp = this.selectedScheduleRows[0];
      item = this.calendarSvc.classSchedulesList.find(x => x.Id_p == tmp.Id_p && x.Id_e == tmp.Id_e);
    }
    else {
      tmp = this.selectedVacationRows[0];
      item = this.calendarSvc.classVacsationsList.find(x => x.VacationId == tmp.VacationId && x.VacationForAccountId == tmp.VacationForAccountId);
    }
    if (item.AuthorityStatuses) {
      this.openAuthorityStatusDialog(item.AuthorityStatuses);
    }
    else {
      let itemId = this.mainScheduleSelected ? item.Id_p : item.VacationId;
      if (itemId != null) {
        this.calendarSvc.spinnerSubjectEmit(true);
        this.calendarSvc.getAuthorityStatuses(itemId, this.mainScheduleSelected ? "new_account_scheduleid" : "new_holidaycalendarid").then((res: any) => {
          if (!this.calendarSvc.dataService.IsError(res)) {
            item.AuthorityStatuses = JSON.parse(res);
            this.calendarSvc.spinnerSubjectEmit(false);
            this.openAuthorityStatusDialog(item.AuthorityStatuses);
          }
        }).catch(err => {
          debugger
          this.calendarSvc.spinnerSubjectEmit(false);
        });
      }
      else {
        this.openAuthorityStatusDialog(null);
      }
    }
  }

  openAuthorityStatusDialog(data: AuthorityStatus[]) {
    const dialogRef = this.dialog.open(AuthoritiesStatusDialogComponent, {
      panelClass: 'full-width-dialog',
      hasBackdrop: true,
      autoFocus: true,
      // disableClose: true,
      data: data,
    });
  }

  openAddClassScheduleDialog() {
    const dialogRef = this.dialog.open(AddClassScheduleDialogComponent, {
      width: '400px'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Class schedule saved successfully');
        this.callbackLoadClassSchedules();
      }
    });
  }
}
